import { render, staticRenderFns } from "./ManagementDocumentInfoProvider.vue?vue&type=template&id=1a1a9ac4"
import script from "./ManagementDocumentInfoProvider.vue?vue&type=script&lang=ts"
export * from "./ManagementDocumentInfoProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1a9ac4')) {
      api.createRecord('1a1a9ac4', component.options)
    } else {
      api.reload('1a1a9ac4', component.options)
    }
    module.hot.accept("./ManagementDocumentInfoProvider.vue?vue&type=template&id=1a1a9ac4", function () {
      api.rerender('1a1a9ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/ManagementDocumentInfoProvider.vue"
export default component.exports